var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { replaceAll } from "framework/helpers";
import { updateByCollectionResponse } from "framework/state/collection";
import { NoEntityError } from "framework/validation/validatableentity";
import { getMemberLoanStatusText, getMemberLoanStatusValues } from "common/member_loans/entity";
import { loadListOfMemberLoans } from "common/member_loans/endpoint";
var filterSelectOptions = [{ key: "undefined", value: "vše" }].concat(getMemberLoanStatusValues().map(function (s) {
    return {
        key: s.valueOf().toString(),
        value: getMemberLoanStatusText(s)
    };
}));
var initialize = function (clubId) { return function (store) {
    store.setState(function (draft) {
        draft.data = [];
        draft.collection = [];
        draft.columnInfo = [
            { heading: "IDT", field: "memberIdt", sortable: false, filterable: true, equalityFilter: true },
            { heading: "jméno", field: "memberName", sortable: false, filterable: true },
            { heading: "příjmení", field: "memberSurname", sortable: false, filterable: true },
            clubId === null
                ? { heading: "do klubu", field: "hostingClubName", sortable: false, filterable: true }
                : { heading: "z klubu", field: "memberClubName", sortable: false, filterable: false },
            { heading: "od data", field: "fromDate", sortable: false, filterable: false },
            { heading: "do data", field: "toDate", sortable: false, filterable: false },
            { heading: "stav", field: "status", sortable: false, filterable: true, equalityFilter: true, filterSelectOptions: filterSelectOptions, multiOption: true },
        ];
        draft.columnStates = [
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
        ];
        draft.pageSize = 25;
        draft._initialized = true;
        draft.clubId = clubId !== null && clubId !== void 0 ? clubId : null;
        draft.clubLoansDirection = clubId === null ? 'fromClub' : 'intoClub';
    });
}; };
var setLoansDirection = function (direction) { return function (store) {
    var state = store.getState();
    store.setState(function (draft) {
        draft.data = [];
        draft.collection = [];
        draft.columnInfo[3] = direction === 'fromClub'
            ? { heading: "do klubu", field: "hostingClubName", sortable: false, filterable: true }
            : { heading: "z klubu", field: "memberClubName", sortable: false, filterable: false };
        draft.columnStates = state.columnStates;
        draft.columnStates[3] = { filter: "", sort: null };
        draft.clubLoansDirection = direction;
    });
    store.dispatch(loadData());
}; };
var getQueryParameters = function (state) {
    var params = {};
    params["page"] = state.pageNumber.toString();
    params["pageSize"] = state.pageSize.toString();
    var sortSpecification = [];
    state.columnStates.forEach(function (cs, cs_idx) {
        if (cs.sort !== null) {
            sortSpecification.push("".concat(replaceAll(state.columnInfo[cs_idx].field, ".", "/"), " ").concat(cs.sort));
        }
    });
    var orderby = sortSpecification.length == 0 ? null : sortSpecification.join(",");
    if (orderby !== null) {
        params["order"] = orderby;
    }
    var filteredFieldIdxs = state.columnInfo.map(function (ci, ci_idx) { return ci_idx; }).filter(function (idx) { return state.columnStates[idx].filter !== "" && state.columnStates[idx].filter !== "undefined"; });
    var filter = filteredFieldIdxs.length == 0 ?
        null :
        filteredFieldIdxs.map(function (idx) {
            var filterValue = state.columnInfo[idx].multiOption ? "('".concat(state.columnStates[idx].filter.toString(), "')") : "'".concat(state.columnStates[idx].filter.toString(), "'");
            var filterOperator = state.columnInfo[idx].multiOption ? 'IN' : (state.columnInfo[idx].equalityFilter === true ? '=' : 'LIKE');
            return "".concat(replaceAll(state.columnInfo[idx].field, ".", "/"), " ").concat(filterOperator, " ").concat(filterValue);
        }).join(' and ');
    if (state.clubId !== null) {
        var loanDirectionFilterField = state.clubLoansDirection === 'intoClub' ? 'hostingClubId' : 'memberClubId';
        var loanDirectionFilter = "".concat(loanDirectionFilterField, "=").concat(state.clubId);
        if (filter !== null && filter !== '') {
            filter = "".concat(filter, " and ").concat(loanDirectionFilter);
        }
        else {
            filter = "".concat(loanDirectionFilter);
        }
    }
    if (filter !== null && filter !== '') {
        params["filter"] = filter;
    }
    return params;
};
var loadData = function () { return function (store) {
    var state = store.getState();
    var params = getQueryParameters(store.getState());
    var loader = function () { return loadListOfMemberLoans(params); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
            if (response.succeeded) {
                draft.data = draft.collection;
                draft.paging.page = response.data.paging.page;
                draft.paging.pageSize = response.data.paging.pageSize;
                draft.paging.totalCount = response.data.paging.totalCount;
                draft.pageCount = Math.ceil(draft.paging.totalCount / draft.pageSize);
            }
            else {
                draft.data = [];
                draft.pageNumber = 1;
                draft.pageCount = 0;
            }
        });
    };
    loadLast(store, loader, stateProducer);
}; };
var getColumnIndexByField = function (field, store) {
    var s = store.getState();
    var res = s.columnInfo.find(function (x) { return x.field === field; });
    return s.columnInfo.indexOf(res);
};
var setFilter = function (field, value) { return function (store) {
    var idx = getColumnIndexByField(field, store);
    if (idx >= 0) {
        store.setState(function (draft) {
            draft.columnStates[idx].filter = value;
            draft.pageNumber = 1;
        });
        store.dispatch(loadData());
    }
}; };
var setOrder = function (field, value) {
    if (value === void 0) { value = null; }
    return function (store) {
        var idx = getColumnIndexByField(field, store);
        if (idx >= 0) {
            var current_sort = store.getState().columnStates[idx].sort;
            var new_sort_1 = current_sort === null ? "asc" : current_sort === "asc" ? "desc" : null;
            store.setState(function (draft) {
                draft.columnStates.forEach(function (cs) { return cs.sort = null; });
                draft.columnStates[idx].sort = new_sort_1;
            });
            store.dispatch(loadData());
        }
    };
};
var setPageNumber = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.pageNumber = val;
    });
    store.dispatch(loadData());
}; };
var setPageSize = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.pageSize = val;
        draft.pageNumber = 1;
    });
    store.dispatch(loadData());
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), data: [], columnInfo: [], columnStates: [], pageNumber: 1, pageCount: 0, pageSize: 25, _initialized: false, paging: {
        page: 1,
        pageSize: 25,
        totalCount: 0,
    }, clubId: null, clubLoansDirection: 'intoClub' });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFilter: setFilter,
        setOrder: setOrder,
        initialize: initialize,
        loadData: loadData,
        setPageNumber: setPageNumber,
        setPageSize: setPageSize,
        setLoansDirection: setLoansDirection,
    },
    name: "MembersListAdmin"
});
var useState = createHook(store);
export { StateDefaults as MembersAdminDefaults, useState as useMemberLoanListAdmin, };
